import { render } from "./agent-card-simple.vue?vue&type=template&id=07621fa6"
import script from "./agent-card-simple.vue?vue&type=script&lang=js"
export * from "./agent-card-simple.vue?vue&type=script&lang=js"

import "./agent-card-simple.vue?vue&type=style&index=0&id=07621fa6&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-team/_components/agent-card-simple.vue'],['render',render],['__file',"agent-card-simple.vue"]])

export default __exports__